import type { AppDefinition } from '../../types/apps';

export const SkillsAppV2Definition: AppDefinition = {
  appId: 'skills-v2',
  name: 'Skill',
  version: '1.0.0',
  description: 'Reusable skill definitions for AI workflows',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'Cpu',
    phosphorWeight: 'duotone',
  },
  entityIcons: {
    Skill: {
      type: 'phosphor',
      phosphorIcon: 'Cpu',
      phosphorWeight: 'duotone',
      color: '#10b981',
    },
  },
  entityTypes: ['Skill'],
  component: 'skills-v2',
  requiresProps: false,
  requiresEntity: true,
  actions: {},
  // No standalone app icon (Dock/Store/CreateMenu Apps section) — "New Skill"
  // stays available as a quick-create entry everywhere.
  hidden: true,
};
